var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',_vm._l((_vm.investorPartners),function(investorPartner,index){return _c('prismic-link',{key:`investorPartner${index}`,attrs:{"link":investorPartner.article || investorPartner.link}},[_c('img',{attrs:{"src":investorPartner.logo.url,"alt":investorPartner.title}})])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }